import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getLeases(params) {
        const response = await axios.get(API_URL + "/getleases", { headers: authHeader(), params: params });
        return { data: response.data, meta: response.data.meta?.page };
    },

    async addLease(lease) {
        lease.type = "leases"
        const newJson = dataFormatter.serialize({ stuff: lease })
        const response = await axios.post(API_URL + "/addlease", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deleteLease(leaseId) {
        await axios.delete(API_URL + "/leases/" + leaseId, { headers: authHeader() });
    },

    async getLease(leaseId) {
        const response = await axios.get(API_URL + "/leases/" + leaseId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editLease(lease) {
        lease.type = "leases"
        const newJson = dataFormatter.serialize({ stuff: lease })
        const response = await axios.patch(API_URL + "/leases/" + lease.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




